import React from "react";
import { QuantityPickerClassName, updateQuantity } from "./logic";

import "./index.scss";

const QuantityPicker = ({
  quantity,
  setQuantity,
  maxQuantity,
  minQuantity,
  className,
}) => {
  const addQuantity = () =>
    updateQuantity(quantity + 1, minQuantity, maxQuantity, setQuantity);
  const substractQuantity = () =>
    updateQuantity(quantity - 1, minQuantity, maxQuantity, setQuantity);
  const maxQuantityClassName = QuantityPickerClassName(quantity, maxQuantity);
  const minQuantityClassName = QuantityPickerClassName(
    quantity,
    null,
    minQuantity
  );
  return (
    <div className={`${"quantityPicker"} ${className}`}>
      <div
        className={minQuantityClassName}
        role="button"
        tabIndex={0}
        onClick={() => substractQuantity()}
        onKeyPress={() => substractQuantity()}
      >
        -
      </div>
      <span
        className={"quantity"}
      >
        {quantity}
      </span>
      <div
        className={maxQuantityClassName}
        role="button"
        tabIndex={0}
        onClick={() => addQuantity()}
        onKeyPress={() => addQuantity()}
      >
        +
      </div>
    </div>
  );
};

export default QuantityPicker;
